import { ReactNode, useCallback } from 'react'
import {
  SetupNotificationsLayout,
  HubEventHandler,
} from 'layout/SetupNotificationsLayout'
import { HUB_NAMES } from 'constants/signalrConstants'
import {
  NotificationType,
  CampaignUpdatedEvent,
  TaskUpdatedNotification,
  PdfProcessedEvent,
  TaskCreatedNotification,
} from 'types/pushNotifications'
import { emitTaskUpdate } from '../hooks/useAutopilotTaskUpdates'
import { useQueryClient } from '@tanstack/react-query'
import { handleCampaignUpdated } from './appNotificationsHandlers'
import { emitPdfProcessedEvent } from 'hooks/usePdfProcessedEvent'
import { emitTaskCreatedEvent } from 'hooks/useTaskCreatedEvent'
import {
  useInvalidateUseGetArchivedCampaignsByAdmin,
  useInvalidateUseGetCampaignsForAgency,
} from '@urbanx/agx.campaigns.client'

interface SignalrCommsProps {
  children: ReactNode
}

const handleAppNotificationsConnected = () =>
  console.log('AppNotifications hub connected')

const handleAutopilotTasksConnected = () =>
  console.log('AutopilotTasks hub connected')

const SignalrComms = ({ children }: SignalrCommsProps) => {
  const queryClient = useQueryClient()
  const invalidateCampaigns = useInvalidateUseGetCampaignsForAgency()
  const invalidateArchivedCampaigns =
    useInvalidateUseGetArchivedCampaignsByAdmin()

  const appNotificationHandlers: HubEventHandler[] = [
    {
      eventType: NotificationType.CampaignUpdatedEvent,
      handler: useCallback(
        (event: CampaignUpdatedEvent) =>
          handleCampaignUpdated(event, queryClient, [
            invalidateCampaigns,
            invalidateArchivedCampaigns,
          ]),
        [queryClient]
      ),
    },
    {
      eventType: NotificationType.PdfProcessedEvent,
      handler: useCallback(
        (event: PdfProcessedEvent) => emitPdfProcessedEvent(event),
        []
      ),
    },
  ]

  const autopilotTaskHandlers: HubEventHandler[] = [
    {
      eventType: NotificationType.TaskUpdatedNotification,
      handler: useCallback(
        (event: TaskUpdatedNotification) => emitTaskUpdate(event),
        []
      ),
    },
    {
      eventType: NotificationType.TaskCreatedNotification,
      handler: useCallback(
        (event: TaskCreatedNotification) => emitTaskCreatedEvent(event),
        []
      ),
    },
  ]
  return (
    <SetupNotificationsLayout
      hubName={HUB_NAMES.APP_NOTIFICATIONS}
      eventHandlers={appNotificationHandlers}
      onConnected={handleAppNotificationsConnected}
    >
      <SetupNotificationsLayout
        hubName={HUB_NAMES.AUTOPILOT_TASKS}
        eventHandlers={autopilotTaskHandlers}
        onConnected={handleAutopilotTasksConnected}
      >
        {children}
      </SetupNotificationsLayout>
    </SetupNotificationsLayout>
  )
}

export default SignalrComms
